import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import { Column, Row } from '../cc-table.context';

interface DefaultCardProps {
  columns: Column[];
  row: Row;
}

export const DefaultCard = ({ columns, row }: DefaultCardProps) => {
  return (
    <Paper>
      <Box sx={{ paddingX: 2, paddingY: 1, position: 'relative' }}>
        <Grid container spacing={1}>
          {columns.map(({ id, render, mobileSx = {} }, index) => {
            if (render && render(row)) {
              return (
                <Grid key={`cc-table-card-col-${index}`} item xs={12}>
                  <Box sx={mobileSx}>{render(row)}</Box>
                </Grid>
              );
            }

            if (render && !render(row)) {
              return null;
            }

            const columnVal = row[id];

            if (!columnVal || (columnVal && Array.isArray(columnVal) && columnVal.length === 0)) {
              return null;
            }

            return (
              <Grid key={`cc-table-card-col-${index}`} item xs={12}>
                <Box sx={mobileSx}>
                  <Typography variant="body2">{Array.isArray(columnVal) ? columnVal.join(', ') : columnVal}</Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Paper>
  );
};
